export default __webpack_public_path__ + "static/media/Background_00102.c02398de.png";